/* unplugin-vue-components disabled */import { render } from "./UpdatePassword.vue?vue&type=template&id=69937735"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=69937735&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__